import React from "react";
import {useTranslation} from "react-i18next";
import {NavLink, useRouteMatch} from "react-router-dom";

const MenuLateralComponent = () => {
    const {t} = useTranslation();
    const match = useRouteMatch();

    return (
        <div className="card card-custom">
            <div className="card-body d-flex flex-column p-5">
                <ul className="nav nav-pills flex-column">
                    <li className="nav-item">
                        <NavLink to={`${match.path}/`} exact className="nav-link" activeClassName="active">
                            {t(`PROFILE.MENU.BASIC_INFO`)}
                        </NavLink>
                    </li>
                    <li className="nav-item">
                        <NavLink to={`${match.path}/access`} exact className="nav-link" activeClassName="active">
                            {t(`PROFILE.MENU.ACCESS_METHODS`)}
                        </NavLink>
                    </li>
                    {/*<li className="nav-item">*/}
                    {/*    <NavLink to={`${match.path}/external`} exact className="nav-link" activeClassName="active">*/}
                    {/*        {t(`PROFILE.MENU.EXTERNAL`)}*/}
                    {/*    </NavLink>*/}
                    {/*</li>*/}
                </ul>
            </div>
        </div>
    );
};

export default MenuLateralComponent;
